import { render, staticRenderFns } from "./activeGoodsItem.vue?vue&type=template&id=502743cc&scoped=true&"
import script from "./activeGoodsItem.vue?vue&type=script&lang=js&"
export * from "./activeGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./activeGoodsItem.vue?vue&type=style&index=0&id=502743cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502743cc",
  null
  
)

export default component.exports